<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <!-- <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} Cấp mã MS</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} Cấp mã MS</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} Cấp mã MS</span>-->
        <span>Nhập danh sách điểm đến</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row class="mt-3 mb-3">
            <b-col md="2">
              <b-link
                class="el-button el-button--info el-button--small is-plain"
                :href="aExtension.urlFilesTemplate.DsDDATMau"
              >
                <i class="fa fa-download"></i> File excel mẫu
              </b-link>
            </b-col>
            <b-col md="4">
              <el-upload
                action
                :auto-upload="false"
                list-type="text"
                :limit="mData.fileUploadOption.DsDiemDenAnToan.limit"
                :accept="mData.fileUploadOption.DsDiemDenAnToan.accept"
                :on-change="fn_uploadChangeDsDiemDenAnToan"
                :on-exceed="fn_uploadExceedDsDiemDenAnToan"
                :file-list="mData.fileUploadOption.DsDiemDenAnToan.fileList"
                :disabled="mData.viewMode == 'detail'"
                multiple
              >
                <el-button size="small" type="info" plain>
                  <i class="fa fa-upload"></i> Upload file
                </el-button>
              </el-upload>
            </b-col>
          </b-row>

          <el-alert
            class="mb-2"
            title="Vui lòng kiểm tra lại dữ liệu tải lên!"
            type="error"
            show-icon
            v-if="mData.dialogDiemDenAnToan.hasError"
          ></el-alert>

          <el-table
            :data="mData.dialogDiemDenAnToan.list"
            border
            max-height="400"
            style="width: 100%"
            :row-class-name="fn_errorRow"
          >
            <el-table-column type="expand" v-if="mData.dataDefault.sended">
              <template slot-scope="props">
                <p
                  :style="{color: props.row.reason ? mData.dataDefault.color.error : mData.dataDefault.color.active,'margin-bottom': 0}"
                >{{ props.row.status }}</p>
                <p
                  style="color: #f53131;margin-bottom: 0;"
                  v-if="props.row.reason"
                >Lý do lỗi: {{props.row.reason}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="excel_stt" label="STT" align="center" width="50"></el-table-column>
            <el-table-column prop="excel_ten_dd" label="Tên điểm đến" min-width="150">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_ten_dd', scope.row.excel_ten_dd)"
                >{{scope.row.excel_ten_dd}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_loai_dd"
              label="Loại điểm đến"
              min-width="150"
              width="auto"
            >
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_loai_dd', scope.row.excel_loai_dd)"
                >{{scope.row.excel_loai_dd}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_sdt" label="Số điện thoại" align="left" width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_sdt', scope.row.excel_sdt)"
                >{{scope.row.excel_sdt}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_tinh" label="Tỉnh" min-width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_tinh', scope.row.excel_tinh)"
                >{{scope.row.excel_tinh}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_huyen" label="Quận/Huyện" min-width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_huyen', scope.row.excel_huyen)"
                >{{scope.row.excel_huyen}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_xa" label="Xã/Phường" min-width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_xa', scope.row.excel_xa)"
                >{{scope.row.excel_xa}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_dia_chi" label="Địa chỉ" min-width="120">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_dia_chi', scope.row.excel_dia_chi)"
                >{{scope.row.excel_dia_chi}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_mst" label="Mã số thuế" min-width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_mst', scope.row.excel_mst)"
                >{{scope.row.excel_mst}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_ten_ndd" label="Tên người đại diện" min-width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_ten_ndd', scope.row.excel_ten_ndd)"
                >{{scope.row.excel_ten_ndd}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_chuc_vu_ndd" label="Chức vụ" min-width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_chuc_vu_ndd', scope.row.excel_chuc_vu_ndd)"
                >{{scope.row.excel_chuc_vu_ndd}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_so_giay_to"
              label="Số CMT/Căn cước/Hộ chiếu"
              min-width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_so_giay_to', scope.row.excel_so_giay_to)"
                >{{scope.row.excel_so_giay_to}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="excel_ngay_sinh_ndd" label="Ngày sinh" align="right" width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_ngay_sinh_ndd', scope.row.excel_ngay_sinh_ndd, scope.row.excel_thang_sinh_ndd, scope.row.excel_nam_sinh_ndd)"
                >{{scope.row.excel_ngay_sinh_ndd}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_thang_sinh_ndd"
              label="Tháng sinh"
              align="right"
              width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_thang_sinh_ndd', scope.row.excel_ngay_sinh_ndd, scope.row.excel_thang_sinh_ndd, scope.row.excel_nam_sinh_ndd)"
                >{{scope.row.excel_thang_sinh_ndd}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="excel_nam_sinh_ndd" label="Năm sinh" align="right" width="100">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_nam_sinh_ndd', scope.row.excel_ngay_sinh_ndd, scope.row.excel_thang_sinh_ndd, scope.row.excel_nam_sinh_ndd)"
                >{{scope.row.excel_nam_sinh_ndd}}</span>
              </template>
            </el-table-column>-->
            <!-- <el-table-column prop="excel_gt_ndd" label="Giới tính" align="center" width="60">
              <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT(scope.row, 'excel_gt_ndd', scope.row.excel_gt_ndd)"
                >{{scope.row.excel_gt_ndd}}</span>
              </template>
            </el-table-column>-->

            <!-- <el-table-column prop="excel_email" label="Email" align="center" width="100"></el-table-column> -->

            <!-- <el-table-column
              prop="excel_dia_chi_ndd"
              label="Địa chỉ người đại diện"
              align="left"
              min-width="100"
            >-->
            <!-- <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelDDAT('excel_ngay_sinh', scope.row.excel_ngay_sinh, scope.row.excel_thang_sinh, scope.row.excel_nam_sinh)"
                >{{scope.row.excel_ngay_sinh}}</span>
            </template>-->
            <!-- </el-table-column> -->

            <!-- <el-table-column
              fixed="right"
              label="Duyệt"
              align="center"
              v-if="mData.dialogDiemDenAnToan.hasError"
            >
              <template slot-scope="scope">
                <i class="el-icon-error" style="color: #e01219;" v-if="!scope.row.check"></i>
                <i class="el-icon-success" style="color: #19d916;" v-if="scope.row.check"></i>
              </template>
            </el-table-column>-->
          </el-table>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_addValueDDAT"
              :disabled="mData.dialogDiemDenAnToan.hasError||mData.dialogDiemDenAnToan.list.length<=0"
            >Đăng ký</el-button>
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>-->

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DiemDenAnToanModel from "./DiemDenAnToanModel";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      aExtension: ExtensionService,
      mData: {
        viewMode: "create",
        moduleName: "DiemDenAnToan",
        dataDefault: {
          roles: DataService.rolesInForm,
          sended: false,
          color: { active: "#4287f5", error: "#f53131" },
          listDDAT: [],
          listLoaiDDAT: DataService.loaiHinhRegister,
        },
        dataForm: MethodService.copyObject(DiemDenAnToanModel.dataForm),
        validForm: DiemDenAnToanModel.validForm,
        dialog: {},
        dialogDiemDenAnToan: {
          list: [],
          visible: false,
          hasError: false,
        },
        excelDiemDenAnToan: MethodService.copyObject(
          DiemDenAnToanModel.excelDiemDenAnToan
        ),
        fileUploadOption: {
          DsDiemDenAnToan: {
            limit: 1,
            accept: ".xlsx",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await DiemDenAnToanApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await DiemDenAnToanApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      // let res = await DiemDenAnToanApi.findById(id, "id,code,name,index");
      // this.mData.dataForm = res.result;
    },

    async fn_uploadChangeDsDiemDenAnToan(file, fileList) {
      this.mData.dataDefault.sended = false;
      let valueFile = await MethodService.readExcel(file.raw);
      if (valueFile.length > 1) {
        this.fn_formatExcelRow(valueFile);
      } else {
        toastr.error("Dữ liệu trong file trống");
      }
    },

    fn_formatExcelRow(valueFile) {
      // merge từ index excel sang tên code: value
      var arrKhachDuLich = [];
      var arrTenDDAT = [];
      $.each(valueFile, (iFile, elFile) => {
        let newObject = {};
        if (iFile > 0) {
          $.each(elFile, (iFileItem, elFileItem) => {
            $.each(
              this.mData.excelDiemDenAnToan.configIndex,
              (iModel, elModel) => {
                if (iFileItem == elModel.index) {
                  newObject[elModel.code] = elFileItem;
                  if (iFileItem == 1) {
                    arrTenDDAT.push(iFileItem);
                  }
                }
              }
            );
          });
          arrKhachDuLich.push(newObject);
        }
      });

      this.mData.dialogDiemDenAnToan.list = arrKhachDuLich;
      this.mData.dialogDiemDenAnToan.visible = true;
      this.mData.dialogDiemDenAnToan.hasError = false;
      //   let resFind = await DiemDenAnToanApi.list({limit:10000,filters:"thong_tin_chung.ten:regex_i:"+arrTenDDAT.join(',')});
      //         if (resFind.result&&resFind.result.length>0){
    },

    async fn_addValueDDAT() {
      var arrNew = [];

      $.each(this.mData.dialogDiemDenAnToan.list, (iKhach, elKhach) => {
        let objNew = MethodService.copyObject(
          DiemDenAnToanModel.excelDiemDenAnToan.formModel
        );

        objNew.ho_ten = elKhach.excel_ten_ndd ? elKhach.excel_ten_ndd : "";
        objNew.chuc_vu = elKhach.excel_chuc_vu_ndd
          ? elKhach.excel_chuc_vu_ndd
          : "";
        // objNew.gioi_tinh = elKhach.excel_gt_ndd?elKhach.excel_gt_ndd:"";
        objNew.user_so_giay_to = elKhach.excel_so_giay_to
          ? elKhach.excel_so_giay_to
          : "";

        // objNew.dia_chi_lien_lac = elKhach.excel_dia_chi_ndd
        //   ? elKhach.excel_dia_chi_ndd
        //   : "";
        objNew.ma_so_thue = elKhach.excel_mst ? elKhach.excel_mst : "";
        // objNew.ngay_sinh =
        //   elKhach.excel_nam_sinh_ndd &&
        //   elKhach.excel_thang_sinh_ndd &&
        //   elKhach.excel_ngay_sinh_ndd
        //     ? elKhach.excel_ngay_sinh_ndd.toString() +
        //       "/" +
        //       elKhach.excel_thang_sinh_ndd.toString() +
        //       "/" +
        //       elKhach.excel_nam_sinh_ndd.toString()
        //     : "";
        // objNew.email = elKhach.excel_email ? elKhach.excel_email : "";
        objNew.user_ten = elKhach.excel_ten_dd ? elKhach.excel_ten_dd : "";
        // objNew.user_loai = elKhach.excel_loai_dd
        //   ? elKhach.excel_loai_dd
        //   : "";

        objNew.ten_tinh = elKhach.excel_tinh ? elKhach.excel_tinh : "";
        objNew.ten_huyen = elKhach.excel_huyen ? elKhach.excel_huyen : "";
        objNew.ten_xa = elKhach.excel_xa ? elKhach.excel_xa : "";
        objNew.user_dia_chi = elKhach.excel_dia_chi
          ? elKhach.excel_dia_chi
          : "";
        // objNew.giay_to_noi_cap = elKhach.excel_giay_to_dd
        //   ? elKhach.excel_giay_to_dd
        //   : "";
        // objNew.giay_to_dia_chi = elKhach.excel_giay_to_dc_dd
        //   ? elKhach.excel_giay_to_dc_dd
        //   : "";
        // objNew.giay_to_ngay_cap = elKhach.excel_giay_to_nc_dd
        //   ? elKhach.excel_giay_to_nc_dd
        //   : "";
        if (elKhach.excel_sdt) {
          let sdt = elKhach.excel_sdt;
          if (sdt && sdt.startsWith("0")) {
            sdt = "84" + sdt.substr(1, sdt.length);
          } else if (sdt && !sdt.startsWith("84")) {
            sdt = "84" + sdt;
          }
          elKhach.excel_sdt = sdt;
          objNew.user_dien_thoai = sdt;
        } else {
          objNew.user_dien_thoai = "";
        }

        if (elKhach.excel_gt_ndd) {
          let gioiTinh = DataService.gioiTinhRegister.find((element) => {
            return element.text == elKhach.excel_gt_ndd;
          });
          if (gioiTinh) {
            objNew.gioi_tinh = gioiTinh.code;
          } else {
            objNew.gioi_tinh = "";
          }
        }
        if (elKhach.excel_loai_dd) {
          let loaiHinh = this.mData.dataDefault.listLoaiDDAT.find((element) => {
            //   debugger
            //   console.log("Biệt thự du lịch" == "Biệt thự du lịch");
            //   console.log(element.text);
            //   console.log(elKhach.excel_loai_dd);
            //   console.log(elKhach.excel_loai_dd===element.text);
            return element.text == elKhach.excel_loai_dd;
          });
          if (loaiHinh) {
            objNew.user_loai = loaiHinh.code;
          } else {
            objNew.user_loai = "";
          }
        }

        arrNew.push(objNew);
      });

      let resImport = await DiemDenAnToanApi.importDDAT(
        arrNew
        // this.mData.dataForm.id
      );
      if (
        resImport.result.error == null ||
        resImport.result.error == undefined ||
        resImport.result.error.length == 0
      ) {
        toastr.success("Đăng ký điểm đến thành công");
      } else {
        toastr.error("Có một số lỗi khi đăng ký điểm đến");
        if (
          resImport.result &&
          resImport.result.error &&
          resImport.result.error.length > 0
        ) {
          let cache = resImport.result.error;
          let cacheList = this.mData.dialogDiemDenAnToan.list;
          for(let i = cacheList.length - 1; i >=0; i--)
          {
            let item = cacheList[i];
            let rowData = cache.find(
              (data) => data.user_ten == item.excel_ten_dd
            );
            if (rowData) {
              item["status"] = "Lỗi!";
              item["reason"] = rowData.error_message;
              cache.splice(cache.indexOf(rowData), 1);
            } else {
              item["status"] = "Cấp tài khoản thành công";
            }
          }
          this.mData.dataDefault.sended = true;
        } else {
          this.mData.dialogDiemDenAnToan.list.forEach((item) => {
            item["status"] = "Cấp tài khoản thành công";
          });
          this.mData.dataDefault.sended = true;
        }
      }
      this.mData.dialogDiemDenAnToan.visible = false;

      // this.fn_getDataById(this.mData.dataForm.id);
    },
    fn_uploadExceedDsDiemDenAnToan(files, fileList) {
      this.mData.dataDefault.sended = false;
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.DsDiemDenAnToan.limit} file`
      );
    },
    fn_formatterTableExcelDDAT(
      scope,
      colName,
      colVal,
      colVal2,
      colVal3,
      colVal4,
      colVal5,
      colVal6,
      colVal7
    ) {
      if (colName == "excel_ten_dd") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          //    let resFind = await DiemDenAnToanApi.list({limit:1,filters:"thong_tin_chung.ten:regex_i:"+colVal});
          //     if (resFind.result&&resFind.result.length>0){
          //         this.mData.dialogDiemDenAnToan.hasError = true;
          //         debugger
          //         scope["check"] = false;
          //         return "bg-danger bg-column";
          //     } else {
          //         if (scope["check"] == undefined) {
          //             scope["check"] = true;
          //         }
          //     }
        }
      }
      if (colName == "excel_loai_dd") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_sdt") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_tinh") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_huyen") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_xa") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_dia_chi") {
        if (!colVal) {
          this.mData.dialogDiemDenAnToan.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }

      // if (colName == "excel_dien_thoai") {
      //   if (colVal && !MethodService.checkSDT(colVal)) {
      //     this.mData.dialogDiemDenAnToan.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      // if (colName == "excel_so_the") {
      //   if (colVal && colVal.length != 9 && colVal.length != 16) {
      //     this.mData.dialogDiemDenAnToan.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      if (colName == "excel_ngay_sinh_ndd") {
        //colVal = ngay, colVal2 = thang, colVal3 = nam
        if (colVal) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogDiemDenAnToan.hasError = true;
            scope["check"] = false;
            return "bg-danger bg-column";
          } else {
            if (scope["check"] == undefined) {
              scope["check"] = true;
            }
          }
        }
      }
      if (colName == "excel_thang_sinh_ndd") {
        if (colVal) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogDiemDenAnToan.hasError = true;
            scope["check"] = false;
            return "bg-danger bg-column";
          } else {
            if (scope["check"] == undefined) {
              scope["check"] = true;
            }
          }
        }
      }
      //   if (colName == "excel_nam_sinh_ndd") {
      //     if (!colVal) {
      //       this.mData.dialogDiemDenAnToan.hasError = true;
      //       scope["check"] = false;
      //       return "bg-danger bg-column";
      //     } else {
      //       if (scope["check"] == undefined) {
      //         scope["check"] = true;
      //       }
      //     }
      //   }
      //   if (colName == "excel_gioi_tinh") {
      //     if (!colVal) {
      //       this.mData.dialogDiemDenAnToan.hasError = true;
      //       scope["check"] = false;
      //       return "bg-danger bg-column";
      //     } else {
      //       if (scope["check"] == undefined) {
      //         scope["check"] = true;
      //       }
      //     }
      //   }
    },

    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_errorRow({ row, rowIndex }) {
      if (row.reason) {
        return "error-row";
      } else {
        return "";
      }
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>

<style lang="scss">
.el-table {
  .error-row {
    background-color: #f9b6b6 !important;
  }
}
</style>